import script from "./SnailMail.vue?vue&type=script&setup=true&lang=js"
export * from "./SnailMail.vue?vue&type=script&setup=true&lang=js"

import "./SnailMail.vue?vue&type=style&index=0&id=ea258690&lang=scss"

const __exports__ = script;

export default __exports__